
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/security-login",
      function () {
        return require("private-next-pages/settings/security-login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/security-login"])
      });
    }
  